<template>
	<div class="records">
		<div class="recordsCon">
			<div class="recordsContent">
				<div class="lookUp" :style="{paddingBottom:typeName=='subsidy'?'28px':'20px'}">
					<div class="title">
						{{typeName=='inCenter'?'个人中心':typeName=='declare'?'申报记录':'补贴下发记录'}}
					</div>
					<div v-if="typeName=='inCenter'" class="label">
						<div v-for="(item,index) of inList" :key='index' class="li"
							:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
							{{item.name}}
							<div v-if="(invitePending>0||waitPending>0)&&item.status==3" class="unreadCount"></div>
						</div>
					</div>
					<div v-if="typeName=='declare'" class="label">
						<div v-for="(item,index) of deList" :key='index' class="li"
							:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
							{{item.name}}
						</div>
					</div>
				</div>
				
				<div class="lookUp" style="padding-bottom: 20px;" v-if="typeName=='inCenter'&&selectStatus==3">
					<div class="label" style="margin-top: 0;">
						<div class="li" :class="{'active':interviewStatus==2}" @click="changeinterviewStatus(2)">
							面试邀请
							<div v-if="invitePending>0" class="unreadCount"></div>
						</div>
						<div class="li" :class="{'active':interviewStatus==4}" @click="changeinterviewStatus(4)">
							等待面试
							<div v-if="waitPending>0" class="unreadCount"></div>
						</div>
						<div class="li" :class="{'active':interviewStatus==8}" @click="changeinterviewStatus(8)">面试完成</div>
					</div>
				</div>

				<div v-loading="loading" class="list">
					<div class="nodata" v-if="list.length==0">
						<no-Data></no-Data>
					</div>
					<div v-if="typeName=='inCenter'" class="positionList">
						<template v-if="selectStatus==5">
							<div class="msglist" v-for="item in list" :key="item.id">
								<div class="titlebox">
									<div class="left">{{item.content_type}}</div>
									<div class="date">{{item.created_at}}</div>
								</div>
								<div class="content">{{item.content}}</div>
							</div>
						</template>
						<template v-else>
							<div v-for="(item,index) of list" :key="index" class="positionLi" @click="poDetails(item)" :class="{'filter':item.position.status!=0}">
								<div class="top">
									<div class="info">
										<div class="title">
											{{item.position.position_name}}
										</div>
									</div>
									<div class="label">
										<template v-if="item.position.status!=0">
											<div class="pay">暂停招聘</div>
										</template>
										<template v-else>
											<div class="pay" v-if="item.position.type=='2'">{{item.position.salary_part_time_job}}</div>
											<div class="pay">
												{{`${parseFloat((item.position.salary_min/1000).toFixed(1))}-${parseFloat((item.position.salary_max/1000).toFixed(1))}k`}}
											</div>
										</template>
										<template v-if="item.position.tag_name_others">
											<div class="li" v-for="(item,index) in item.position.tag_name_others.split(',')" :key="index" v-if="index<3">
												{{item}}
											</div>
										</template>
									</div>
								</div>
								<div v-if="item.company" class="bottom">
									<el-image :src="item.company.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
									<div class="bottomRi">
										<div class="name">
											<span>{{item.company.simple_name}}</span> {{item.company.person_count}}
										</div>
										<div class="address">
											<span>{{item.company.company_address}}{{item.company.address_detail}}</span>
										</div>
									</div>
								</div>
								<div class="right" v-if="selectStatus==3"></div>
							</div>
						</template>
					</div>
				
				    <div v-if="typeName=='declare'" class="itemList">
						<div v-for="(item,index) of list" :key="index" class="li" @click="policyDe(item.policy.id)" :class="{'filter':item.status==1}">
							<div v-if="item.policy" class="name">
								{{item.policy.title}}
							</div>
							<div class="lis">
								<img src="@/static/timeIcon.png" class="icon" />
								<div>
									{{item.policy.application_start_date.split(' ')[0]}}-{{item.policy.application_end_date.split(' ')[0]}}
								</div>
							</div>
							<div class="lis">
								<img src="@/static/corIcon.png" class="icon" />
								<div>
									{{item.create_company.simple_name}}
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="typeName=='subsidy'" class="recordsList">
						<div v-for="(item,index) of list" :key="index" class="li">
							<div class="top">
								<div class="name">
									{{item.policy.title}}
								</div>
								<div class="num">
									{{item.amount}}元
								</div>
							</div>
							<div class="gary">
								{{item.create_company.company_name}}
							</div>
							<div class="gary">
								{{item.created_at}}
							</div>
						</div>
					</div>
					
				</div>

				<div v-if="total>limit" class="page">
					<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
						@current-change='changePage'>
					</el-pagination>
				</div>

			</div>
			<downCode></downCode>
		</div>
		
		<el-dialog
			v-if="detail"
			title="面试信息"
			:visible.sync="detailShow"
			width="480px">
			<div class="interviewBox" v-loading="detailLoading">
				<div class="title">
					<span v-if="detail.status==2">您收到一份面试邀请</span>
					<span v-if="detail.status==3">拒绝面试邀请</span>
					<span v-if="detail.status==4">等待面试</span>
					<span v-if="detail.status==5">面试已取消</span>
					<span v-if="detail.status==6">企业取消面试</span>
					<span v-if="detail.status==7">面试未到</span>
					<span v-if="detail.status==8">面试完成</span>
				</div>
				
				<div class="companybox">
					<el-image class="logo" :src="detail.company.logo||require('@/static/company.png')" fit="cover"></el-image>
					<div class="info">
						<div class="company">{{detail.company.company_name}}</div>
						<div class="user">
							<div class="text">{{detail.h_r.user_name}} · {{detail.h_r.en_job}}</div>
						</div>
					</div>
				</div>
				
				<div class="infbox">
					<div class="title">面试信息</div>
					<div class="box" v-if="detail.face_date">
						<div class="label">时间：</div>
						<div class="value">{{detail.face_date}}  {{detail.face_time.substring(0,5)}}</div>
					</div>
					<div class="box">
						<div class="label">职位：</div>
						<div class="value">{{detail.position.position_name}} {{detail.position.type==2?detail.position.salary_part_time_job:`${parseFloat((detail.position.salary_min/1000).toFixed(1))}-${parseFloat((detail.position.salary_max/1000).toFixed(1))}k`}}</div>
					</div>
					<div class="box">
						<div class="label">联系人：</div>
						<div class="value">{{detail.h_r.user_name}} · {{detail.h_r.phone}}</div>
					</div>
					<div class="box">
						<div class="label">面试地址：</div>
						<div class="value">{{detail.company.company_address+detail.company.address_detail}}</div>
					</div>
				</div>
				
				<div class="bottombox" v-if="detail.status==2">
					<el-button class="btnsty fail" type="danger" size="medium" @click="refuseInterview()">拒绝</el-button>
					<el-button class="btnsty" type="primary" size="medium" @click="agreeInterview()">接受邀请</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	import { mapState } from 'vuex';
	export default {
		components: { downCode },
		computed: {
		    ...mapState(['invitePending','waitPending']),
		},
		data() {
			return {
				typeName: '', //inCenter个人中心，declare申报，subsidy补贴
				inList: [{
						name: '历史投递',
						status: 1
					},
					{
						name: '沟通过',
						status: 2
					},
					{
						name: '面试管理',
						status: 3
					},
					{
						name: '收藏',
						status: 4
					},
					{
						name: '系统消息',
						status: 5
					},
				],
				deList: [{
						name: '待受理',
						status: 1
					},
					{
						name: '已通过',
						status: 2
					},
					{
						name: '被驳回',
						status: 3
					},
				],
				selectStatus: 1,
				interviewStatus:2,
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit:15,
				detail:null,
				detailShow:false,
				detailLoading:false,
			}
		},
		created() {
			this.typeName = this.$route.name
			this.getList()
		},
		watch:{
			$route(){
				this.typeName=this.$route.name
				this.selectStatus=1
				this.page=1
				this.getList()
			}
		},
		methods: {
			refuseInterview(){
				this.$prompt('请输入拒绝原因', '拒绝面试邀请', {
				    confirmButtonText: '确认拒绝',
				    cancelButtonText: '取消',
					inputType:'textarea',
					inputValidator: (value) => {
						if (!value) return '请输入拒绝原因';
					},
				}).then(({ value }) => {
				    let data = {
				    	delivery_id:this.detail.id,
				    	operator_type:2,
						remarks:value
				    }
				    this.detailLoading = true
				    this.$axios.post('/api/client/User/userInterviewOperator',data).then(res=>{
				    	this.detailLoading = false
				    	if(res.code==200){
				    		this.$eltips(res.msg,'success')
				    		this.detailShow = false
				    		this.getList()
				    	}else{
				    		this.$eltips(res.msg,'error')
				    	}
				    })
				}).catch(() => {});
			},
			agreeInterview(){
				this.$confirm('请注意面试时间并准时参加面试，爽约可能导致您的职位投递收到影响。', '接受邀请', {
					confirmButtonText: '确认接受',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    let data = {
				    	delivery_id:this.detail.id,
				    	operator_type:1
				    }
					this.detailLoading = true
					this.$axios.post('/api/client/User/userInterviewOperator',data).then(res=>{
						this.detailLoading = false
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.detailShow = false
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			getList() {
				this.loading = true
			    let url='',data={page:this.page,limit:this.limit}
				if(this.typeName=='inCenter'){
					if(this.selectStatus==4){
						url='/api/client/User/getPositionCollections'
					}else if(this.selectStatus==5){
						url = '/api/client/ES/messageNotice'
					}else{
						url='/api/client/User/getDeliverList'
						if(this.selectStatus==2){
							url='/api/client/User/getUserChatLogslist'
						}
						if(this.selectStatus==3){
							data.status=this.interviewStatus
						}
					}
				}
				
				if(this.typeName=='declare'){
					url='/api/client/ES/getMyPolicysApply'
					data.status=this.selectStatus
				}
				
				if(this.typeName=='subsidy'){
					url='/api/client/User/getMyPolicySubsidyUser'
				}
				
				this.$axios.get(url, {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
						if(this.typeName=='inCenter'&&this.selectStatus==3){
							if(this.interviewStatus==2)	this.$store.commit('changeInterviewPending',{invite:res.data.total});
							if(this.interviewStatus==4) this.$store.commit('changeInterviewPending',{wait:res.data.total});
						}
						if(this.typeName=='inCenter'&&(this.selectStatus==2||this.selectStatus==4)){
							this.list.forEach(item=>{
								if(item.position&&item.position.company){
									item.company = item.position.company
								}
							})
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			policyDe(id){
				this.$router.push({ name: 'policyDe',query:{id:id}});
			},
			changeStatus(status){
				if(this.selectStatus==status) return;
				this.selectStatus=status
				this.page=1
				this.total = 0
				this.list = []
				this.getList()
			},
			changeinterviewStatus(status){
				if(this.interviewStatus==status) return;
				this.interviewStatus=status
				this.page=1
				this.total = 0
				this.list = []
				this.getList()
			},
			poDetails(item){
				if(this.selectStatus==3){
					this.detail = item;
					this.detailShow = true
				}else{
					if(item.position.status!=0) return;
					this.$router.push({ name: 'positionDe',query: {id:item.position.id } });
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.records {
		position: relative;
		padding: 48px 0;
		min-height:801px ;
		box-sizing: border-box;
		background-size: 100%;

		.recordsCon {
			position: relative;
			z-index: 2;
			width: 1200px;
			margin: 0 auto;
			display: flex;

			.recordsContent {
				flex: 1;
				margin-right: 14px;

				.lookUp {
					background-color: #FFF;
					margin-bottom: 16px;
					padding: 28px 38px 0;
					border-radius: 16px;

					.title {
						color: #151515;
						font-size: 28px;
						
						font-weight: bold;
					}

					.label {
						display: flex;
						align-items: center;
						margin-top: 28px;
						.li {
							color: #151515;
							font-size: 18px;
							font-weight: bold;
							margin-right: 74px;
							cursor: pointer;
							position: relative;
							&:hover {
								color: #51A190;
							}
							.unreadCount {
								width: 7px;
								height: 7px;
								background-color: #FF4444;
								border-radius: 50%;
								position: absolute;
								right: -7px;
								top: -2px;
							}
						}

						.active {
							color: #51A190;
							position: relative;

							&::after {
								content: '';
								display: block;
								width: 20px;
								height: 4px;
								background-color: #51A190;
								border-radius: 16px;
								bottom: -12px;
								left: 50%;
								position: absolute;
								transform: translate(-50%, 0);
							}
						}
					}
				}

				.list {
					min-height: 500px;
					border-radius: 16px;
					overflow: hidden;
					.nodata{
						height: 500px;
						background: #FFF;
					}
					.positionList {
						.positionLi {
							display: flex;
							align-items: center;
							background-color: #FFF;
							padding: 18px 26px;
							margin-bottom: 16px;
							border-radius: 8px;
							cursor: pointer;
							.top {
								flex: 1;

								.info {
									display: flex;
									align-items: center;
									justify-content: space-between;
									margin-bottom: 15px;

									.title {
										color: #151515;
										font-size: 18px;
										width: 260px;
										white-space: nowrap;
										overflow: hidden;
										text-overflow: ellipsis;
										font-weight: bold;
									}
								}

								.label {
									display: flex;
									align-items: center;

									.pay {
										color: #51A190;
										font-size: 15px;
										margin-right: 18px;
										max-width: 100px;
										overflow: hidden;
										text-overflow: ellipsis;
										white-space: nowrap;
									}

									.li {
										padding: 3px 14px;
										background-color: #F5F5F5;
										border-radius: 2px;
										color: #5E5E5E;
										font-size: 13px;
										display: block;
										margin-right: 8px;

										&:last-child {
											margin-right: 0;
										}
									}
								}
							}

							.bottom {
								color: #151515;
								font-size: 14px;
								display: flex;
								align-items: center;
								flex: 1;

								.logo {
									margin-right: 12px;
									border-radius: 2px;
									width: 64px;
									height: 64px;
									flex: 0 0 64px;
								}

								.bottomRi {
									height: 64px;
									display: flex;
									// align-items: center;
									flex-direction: column;
									justify-content: space-around;

									.name {
										span {
											font-weight: bold;
											margin-right: 12px;
											font-size: 18px;
										}
									}
									.address{
										span{
											max-width: 320px;
											display: inline-block;
											overflow: hidden;
											text-overflow: ellipsis;
											white-space: nowrap;
										}
									}
								}
							}
						}
					
						.msglist{
							padding: 20px 32px;
							background: #FFF;
							border-radius: 16px;
							margin-bottom: 18px;
							&:last-child{
								margin-bottom: 0;
							}
							.titlebox{
								display: flex;
								align-items: center;
								justify-content: space-between;
								.left{
									font-size: 16px;
									font-weight: bold;
								}
							}
							.content{
								margin-top: 18px;
								text-align: justify;
								font-size: 15px;
							}
						}
					}
				
				    .itemList{
						.li {
							position: relative;
							margin-bottom: 16px;
							padding: 22px;
							background-color: #FFF;
							border-radius: 8px;
							box-sizing: border-box;
							width: 100%;
							cursor: pointer;
							.name {
								color: #151515;
								font-size: 18px;
								font-weight: bold;
								margin-bottom: 14px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
						
							}
						
							.lis {
								display: flex;
								align-items: center;
								margin-bottom: 4px;
								font-size: 14px;
						
								&:last-child {
									margin-bottom: 0;
								}
						
								.icon {
									width: 15px;
									height: 15px;
									margin-right: 3px;
								}
							}
						}
					}
					.filter{
						filter: gray;
						filter: grayscale(.95);
						-webkit-filter: grayscale(.95);
					}
				
				    .recordsList{
						.li{
							width: 100%;
							padding: 22px;
							box-sizing: border-box;
							border-radius: 16px;
							background-color: #FFF;
							height: 144px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.top{
								display: flex;
								align-items: center;
								font-size: 22px;
								justify-content: space-between;
								.name{
									color: #151515;
									font-weight: bold;
								}
								.num{
									color: #51A190;
								}
							}
							.gary{
								font-size: 15px;
								color: #5E5E5E;
							}
						}
					}
				}

				.page {
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 28px 0 0;
				}
			}
		}

	}

	.interviewBox{
		.title{
			font-weight: bold;
			font-size: 20px;
		}
		.companybox{
			background: #FFFFFF;
			padding: 18px 0;
			display: flex;
			border-radius: 14px;
			margin-top: 12px;
			.logo{
				flex: 0 0 54px;
				width: 54px;
				height: 54px;
				margin-right: 12px;
				border-radius: 4rpx;
			}
			.info{
				.company{
					font-size: 16rpx;
					font-weight: bold;
				}
				.user{
					display: flex;
					align-items: center;
					margin-top: 8px;
					.avatar{
						width: 32px;
						height: 32px;
						margin-right: 8px;
					}
					.text{
						font-size: 14px;
					}
				}
			}
		}
		
		.infbox{
			margin-top: 18px;
			border-radius: 14px;
			background: #FFF;
			.title{
				font-size: 16px;
				font-weight: bold;
				line-height: 1;
				margin-bottom: 16px;
			}
			.box{
				display: flex;
				margin-top: 14px;
				.label{
					flex: 0 0 120px;
					font-size: 14px;
				}
				.value{
					font-size: 14px;
				}
			}
		}
		
		.bottombox{
			margin-top: 32px;
			display: flex;
			align-items: center;
			.btnsty{
				flex: 1;
				text-align: center;
				border-radius: 8px;
				margin-right: 14px;
				&:last-child{
					margin-right: 0;
				}
			}
			.fail{
				flex: .5;
			}
		}
	}
	
</style>